import _throttle from 'lodash/throttle';
import {useCallback, useEffect, useMemo, useState} from 'react';

const THROTTLE_DELAY = 333;
const SCROLL_UP_BUTTON_OFFSET = 300;

export const useScrollUpButton = () => {
    const [isShowUpButton, setIsShowUpButton] = useState<boolean>(false);

    const handleClickUpButton = () => {
        window.scrollTo({behavior: 'smooth', top: 0});
    };

    const handleScroll = useCallback(() => {
        if (SCROLL_UP_BUTTON_OFFSET <= window.scrollY) {
            setIsShowUpButton(true);
        } else {
            setIsShowUpButton(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const throttledScroll = useMemo(
        () => _throttle(handleScroll, THROTTLE_DELAY, {leading: true, trailing: true}),
        [handleScroll],
    );

    useEffect(() => {
        throttledScroll();
        window.addEventListener('scroll', throttledScroll, {passive: true});

        return () => {
            window.removeEventListener('scroll', throttledScroll as EventListener);
            throttledScroll.cancel();
        };
    }, [throttledScroll]);

    return {handleClickUpButton, isShowUpButton};
};
